import { Module } from 'vuex'
import { RootState } from '@/store/types'
import mutations from '@/modules/auth/store/mutation'
import actions from '@/modules/auth/store/actions'
import JWTToken, {ActiveUser, User} from '@/modules/auth/types'

export interface AuthState {
    token: JWTToken | null
    user: User | null
    /**
     * Usuarios activos
     *
     * Son aquellos usuarios que han iniciado sesión en la aplicación en algún momento.
     */
    activeUsers: ActiveUser[]

    /**
     * Cambiando usuario
     *
     * Indica si la aplicación se encuentra transicionando entre un usuario a otro.
     * Esto permite, por ejemplo, mostrar la pantalla del login para autenticarse
     * aunque ya exista otro usuario.
     *
     * @var { boolean }
     */
    changingActiveUser: boolean,

    /**
     * Usuario que va a ser autenticado
     *
     * Cuando un usuario seleccionada otra cuenta desde el menu de usuario la
     * aplicación comienza el proceso para cambiar de usuario actual.
     *
     * La propiedad changingActiveUser indica si la aplicación se encuentra
     * transicionando de usuario. Esta propiedad indica que cuenta ha
     * seleccionado el usuario.
     */
    activeUserToBeAuthenticated: ActiveUser
}

/**
 * Módulo de Vuex con la lógica necesaria para el módulo de autenticación
 */
const module: Module<AuthState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    state: {
        token: null,
        user: null,
        activeUsers: [],
        changingActiveUser: false,
        activeUserToBeAuthenticated: new ActiveUser(),
    },
}

export default module
